module.exports = __webpack_public_path__ + "static/assets/3a2d63269c47aa8244b0d613cf50eb6c.svg";